import type { RouteRecordRaw } from 'vue-router'

import { ROUTES } from '~/scopes/auth/route-names'

import { INSURANCE } from './routes.constants'

const routes: RouteRecordRaw[] = [
  {
    path: 'post-purchase/insurance',
    name: INSURANCE.POST_PURCHASE,
    component: () =>
      import('~/scopes/insurance/pages/PostPurchase/PostPurchase.vue'),
    meta: {
      owners: ['bot-squad-extended-services-front'],
      layout: false,
      auth: {
        required: true,
        redirection: {
          name: ROUTES.AUTH.LOGIN,
          query: { bm_journey: 'checkout' },
        },
      },
      tracking: { contentGroup: 'Insurance Onboarding' },
    },
  },
  {
    path: 'post-purchase/insurance/expired',
    name: INSURANCE.EXPIRED,
    component: () => import('~/scopes/insurance/pages/Expired/Expired.vue'),
    meta: {
      owners: ['bot-squad-extended-services-front'],
      tracking: { contentGroup: 'Insurance Onboarding' },
    },
  },
  {
    path: 'post-purchase/insurance/subscribed',
    name: INSURANCE.SUBSCRIBED,
    component: () =>
      import('~/scopes/insurance/pages/Subscribed/Subscribed.vue'),
    meta: {
      owners: ['bot-squad-extended-services-front'],
      tracking: { contentGroup: 'Insurance Onboarding' },
    },
  },

  // Backwards compatible route for old url
  {
    path: 'checkout',
    redirect: ({ query }) => ({ name: INSURANCE.POST_PURCHASE, query }),
    meta: {
      owners: ['bot-squad-extended-services-front'],
    },
  },
]

export default routes
